module.exports = __webpack_public_path__ + "img/right01-4.f7671e69.png";